import type { OrderItem } from '@octave/contracts';
import { formatPrice } from '@/lib/format';

interface FeeItemMetadataProps {
  item: OrderItem;
}

export function FeeItemMetadata({ item }: FeeItemMetadataProps) {
  const { metadata } = item;

  if (metadata.type !== 'FEES' || !metadata.allocations?.length) {
    return null;
  }

  // Sans nom de centre snapshoté (anciennes commandes, frais non rattaché),
  // il n'y a rien d'utile à détailler.
  if (!metadata.allocations.some((allocation) => allocation.siteName)) {
    return null;
  }

  return (
    <div className="mt-2 text-xs text-gray-500">
      <div>Répartition par centre de facturation</div>
      {metadata.allocations.map((allocation, index) => (
        <div key={allocation.siteId ?? index}>
          {allocation.siteName ?? 'Sans centre'}:{' '}
          {formatPrice(allocation.amount)}
        </div>
      ))}
    </div>
  );
}
